module.exports = __webpack_public_path__ + "static/gallery_kerry_6_thumb-0270f7720e955c2201ac6efb33632986.jpg";